// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.departments', {
        url: '/departments?searchTerm',
        views: {
            'productList@product': {
                templateUrl: 'main/product/departments/departments.tpl.html',
                controller: 'DepartmentsController as vm'
            }
        },
        resolve: {
            departments: departmentsResolver,
            searchTerm: searchTermesolver
        }
    });
}


// @ngInject
function departmentsResolver(DepartmentsApiService, $stateParams) {
    return DepartmentsApiService.getPage({ page: 1, pageSize: 19, searchTerm: $stateParams.searchTerm});
}

// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}

// @ngInject
function DepartmentsController($rootScope, $state, departments, $scope, DepartmentsApiService, loadSpinnerService, searchTerm) {
    var vm = this;

    vm.itemsPerPage = 19;
    vm.selectedDepartmentId = 0;
    vm.departments = departments.results;
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.currentPage = 1;
    vm.totalRows = departments.total;

    vm.searchTermChanged = searchTermChanged;
    vm.pageChanged = pageChanged;

    activate();

    function activate() {
        $rootScope.$on('Department.Changed', function() {
            loadDepartments();
        });
    }

    function loadDepartments() {
        loadSpinnerService.start('mainSpinner');
        DepartmentsApiService.getPage({ page:  vm.currentPage, pageSize: vm.itemsPerPage, searchTerm: vm.searchTerm}).then(function (response) {
            vm.departments = response.results;
            vm.totalRows = response.total;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner', { force: true });
        });
    }

    function searchTermChanged() {
        vm.currentPage = 1;
        loadDepartments();
    }

    function pageChanged() {
        loadDepartments();
    }
}


angular
    .module('product.departments', ['departments.api','departments.department'])
    .config(stateConfig)
    .controller('DepartmentsController', DepartmentsController);
